import './datadogRUM-init';
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/solid';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.css';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import {loadMessages, locale} from 'devextreme/localization';
import ptBrMessages from 'devextreme/localization/messages/pt.json';
import config from "devextreme/core/config";
import './css/dx_generic_cores_raster.css';
import './css/dx.generic.compacto-datagrid.css';
import './css/basicas.css';
import './css/jornada.css';
import './css/menu-ds.css';
import './css/styles.css';
import './css/formulario.css';
import './css/formulario_pre-sm.css';
import './css/dashboard-modern-popup.css';
import "vis-timeline/styles/vis-timeline-graph2d.css";
import {keycloakServiceFactory} from "./services/keycloak";
import selecionaEmpresa from "./login/selecionaEmpresa";
import {login, getCompaniesAllowed, getShippersAllowed} from "./services/auth/api";
import {errorHandler} from "./utils/errorHandler";
import { setUserTheme } from './services/user-theme';
import { getURIRedirect } from './services/auth/utils';
import { configureMovideskChat } from './services/chat-movidesk';
import ControleSessao from './componentes-padrao/ControleSessao';
import { LoginEmbarcadora } from './login/loginEmbarcadora';
import { SelecionaTipoAcesso } from './login/selecionaTipoAcesso';
import { instalarCorrecaoTituloPopup } from './utils/corrigeTituloPopup';

ptBrMessages.pt["dxDataGrid-groupPanelEmptyText"] = "Arrastar o cabeçalho de uma coluna aqui para agrupar por essa coluna";

loadMessages(ptBrMessages)
locale('pt-BR')
config({
    defaultCurrency: 'BRL',
    forceIsoDateParsing: true,
})

// Corrige o truncamento prematuro dos títulos de popups (JOR4-7239): recalcula
// o max-width do título no momento certo, para todos os popups do sistema.
instalarCorrecaoTituloPopup()

const clearParams = (url, params) => {
    params.delete('code');
    params.delete('session_state');
    params.delete('state');

    const novaUrl = `${url.origin}${url.pathname}`;

    history.replaceState(null, '', novaUrl);
}

/**
 * Verifica se o usuário possui acesso ao ePonto/Cliente (login normal),
 * consultando as empresas/embarcadoras permitidas conforme o tipo de acesso.
 */
const usuarioPossuiAcessoEponto = async () => {
    const tipoEmbarcadora = ControleSessao.getTipoEmbarcadora();

    const acessos = tipoEmbarcadora === "E"
        ? await getShippersAllowed()
        : await getCompaniesAllowed();

    return Array.isArray(acessos) && acessos.length > 0;
};

$(async () => {
    try {
        const url = new URL(window.location.href);
        const urlParams = new URLSearchParams(url.search);

        const authorizationCode = urlParams.get("code")
        const sessionState = urlParams.get("session_state")
        const state = urlParams.get("state")

        clearParams(url, urlParams)

        const isLogged = Boolean(authorizationCode && sessionState)

        const keycloakService = keycloakServiceFactory()

        if (!isLogged) {
            keycloakService.redirectToLogin()
            return
        }

        const isValidState = keycloakService.checkValidState(state)

        if (!isValidState) {
            throw {code: 'E_AUTH_INVALID_STATE_AUTHORIZATION'}
        }

        await login(authorizationCode, getURIRedirect())

        // Depois do login, quando já se sabe se o usuário visualiza o chat Movidesk.
        configureMovideskChat()

        await setUserTheme()

        const iniciarLoginNormal = () => {
            const tipoEmbarcadora = ControleSessao.getTipoEmbarcadora();

            if (tipoEmbarcadora === "E") {
                new LoginEmbarcadora();
            } else {
                new selecionaEmpresa();
            }
        };

        if (!ControleSessao.getPossuiVinculoTransportadorExterno()) {
            // Sem vínculo de transportador externo: acesso direto ao ePonto.
            iniciarLoginNormal();
            return;
        }

        // Com vínculo de transportador externo: a tela de seleção de plataforma
        // só deve aparecer quando o usuário também possui acesso ao ePonto/Cliente.
        // Caso contrário (somente transportador), vai direto ao portal.
        const possuiAcessoEponto = await usuarioPossuiAcessoEponto();

        new SelecionaTipoAcesso({
            onLoginNormal: iniciarLoginNormal,
            somenteTransportador: !possuiAcessoEponto,
        });

    } catch (err) {
        errorHandler(err, "auth")
        console.log(err);
    }
})
